<template>
    <div class='page-content'>
        <div class='title'>
            <span>修改k值</span>
        </div>
        <div class='content'>
            <el-form ref="kValueForm" :model="kValueForm"  size="small">
                <el-form-item label="A">
                    <el-input
                        v-model="kValueForm.a"
                        placeholder="请输入A值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('a')" :loading="loadingStates.a" style="margin-left: 10px">确定</el-button>
                </el-form-item>
                <el-form-item label="B">
                    <el-input
                        v-model="kValueForm.b"
                        placeholder="请输入B值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('b')" :loading="loadingStates.b" style="margin-left: 10px">确定</el-button>
                </el-form-item>
                <el-form-item label="C">
                    <el-input
                        v-model="kValueForm.c"
                        placeholder="请输入C值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('c')" :loading="loadingStates.c" style="margin-left: 10px">确定</el-button>
                </el-form-item>
                <el-form-item label="D">
                    <el-input
                        v-model="kValueForm.d"
                        placeholder="请输入D值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('d')" :loading="loadingStates.d" style="margin-left: 10px">确定</el-button>
                </el-form-item>
                <el-form-item label="E">
                    <el-input
                        v-model="kValueForm.e"
                        placeholder="请输入E值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('e')" :loading="loadingStates.e" style="margin-left: 10px">确定</el-button>
                </el-form-item>
                <el-form-item label="F">
                    <el-input
                        v-model="kValueForm.f"
                        placeholder="请输入F值"
                        style="width: 300px"
                    ></el-input>
                    <el-button type="primary" @click="submitKValue('f')" :loading="loadingStates.f" style="margin-left: 10px">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { get, postJson } from '@/utils/request.js';

export default {
    data() {
        return {
            kValueForm: {
                a: '',
                b: '',
                c: '',
                d: '',
                e: '',
                f: ''
            },
            loadingStates: {
                a: false,
                b: false,
                c: false,
                d: false,
                e: false,
                f: false
            }
        };
    },
    created() {
        this.getKValue();
    },
    methods: {
        // 查询k值
        getKValue() {
            get('/kValue/query').then((res) => {
                if (res.success || res.code == 200) {
                    // 回显数据
                    if (res.data) {
                        this.kValueForm = {
                            a: res.data.a || '',
                            b: res.data.b || '',
                            c: res.data.c || '',
                            d: res.data.d || '',
                            e: res.data.e || '',
                            f: res.data.f || ''
                        };
                    }
                } else {
                    this.$message({
                        message: res.msg || res.message || '查询失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((err) => {
                this.$message({
                    message: err.response?.data?.msg || err.response?.data?.message || '查询失败',
                    type: 'error',
                    duration: 2000
                });
            });
        },
        // 提交修改k值
        submitKValue(field) {
            if (!this.kValueForm[field] && this.kValueForm[field] !== 0) {
                this.$message({
                    message: `${field.toUpperCase()}值不能为空`,
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            this.loadingStates[field] = true;
            const submitData = {
                [field]: this.kValueForm[field]
            };
            postJson('/kValue/update', submitData).then((res) => {
                this.loadingStates[field] = false;
                if (res.success || res.code == 200) {
                    this.$message({
                        message: res.msg || res.message || '修改成功',
                        type: 'success',
                        duration: 2000
                    });
                    // 修改成功后重新查询
                    this.getKValue();
                } else {
                    this.$message({
                        message: res.msg || res.message || '修改失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((err) => {
                this.loadingStates[field] = false;
                this.$message({
                    message: err.response?.data?.msg || err.response?.data?.message || '修改失败',
                    type: 'error',
                    duration: 2000
                });
            });
        }
    }
};
</script>

<style lang='scss' scoped>
.page-content {
    padding: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.title {
    width: 100%;
    height: 60px;
    padding-left: 28px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    font-size: 18px;
}

.content {
    flex: 1;
    width: 100%;
    padding: 20px 28px;
    overflow-y: auto;
}
</style>

